import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import ClusterEditItemDetails from "./ClusterEditItemDetails"
import ClusterEditItemArticlesContainer from "./ClusterEditItemArticlesContainer"
import ClusterViewItemTopics from "../view/ClusterViewItemTopics"
import ClusterEditItemConceptsContainer from "./ClusterEditItemConceptsContainer"

const ClusterEditItem = ({ model, onEventChange, onValueChange }) => (
    <ItemDetailsColumns className="item-container" id="cluster-item">
        <ItemDetailsColumn>
            <ClusterEditItemDetails
                title={model.title}
                time={model.time}
                description={model.description}
                image_url={model.image_url}
                onEventChange={onEventChange}
            />
            <ClusterViewItemTopics topics={model.topics} isEditing={true} />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <ClusterEditItemArticlesContainer articles={model.articles} />
            <ClusterEditItemConceptsContainer
                concepts={model.concepts}
                onValueChange={onValueChange}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default ClusterEditItem
